import styled, { css } from 'styled-components';

import { phone, phoneMax, tabletMax } from "../Styles/MediaQueries";
import { HEX } from "../Styles/LegacyColors";
import { commonResets } from "../Styles/Utils";

// TO DO: Extract styles from _commonStyles to packages/styles (WP-255)

const gradient = /*#__PURE__*/css(["@supports (-webkit-background-clip:text){background:linear-gradient(to top right,#ff0045,#3b00ff);-webkit-background-clip:text;-webkit-text-fill-color:transparent;display:inline-block;}"]);









const textCommon = /*#__PURE__*/css(["color:", ";letter-spacing:0;margin-bottom:15px;"],
HEX.darkGrey);




export const StyledTextComponent = /*#__PURE__*/styled.div.attrs(



({ styleModifiers = {}, className, styleMixin }) => {
  const modifiers = Object.keys(styleModifiers).reduce((prev, curr) => {
    return styleModifiers[curr] ? [...prev, curr] : [...prev];
  }, []);

  const mergedClassName = [className, styleMixin, ...modifiers].
  filter((val) => val !== undefined).
  join(' ');

  return { className: mergedClassName };
}).withConfig({ displayName: "Typographystyles__StyledTextComponent", componentId: "sc-1828pku-0" })(["", " & *,&:before,&:before,&:after,&:after{", "}& [data-gradient='true'],& * [data-gradient='true']{", "}&.mini{color:", ";letter-spacing:0;margin-bottom:15px;font-size:12px;line-height:1.45;font-weight:300;}&.small{color:", ";letter-spacing:0;margin-bottom:15px;font-size:16px;line-height:1.45;font-weight:300;}", ""],
commonResets,





commonResets,




gradient,



HEX.darkGrey,









HEX.darkGrey,








(props) => {
  switch (props.tag) {
    case 'h1':
      return css(["", " font-size:71px;font-weight:300;line-height:1.25;&.uppercase{text-transform:uppercase;}&.gradient{", "}@media ", " and ", "{font-size:48px;}"],
      textCommon,










      gradient,


      phone, tabletMax);



    case 'h2':
      return css(["", " font-size:56px;font-weight:300;line-height:1.25;&.uppercase{text-transform:uppercase;}&.lined{position:relative;padding-bottom:49px;&:after{content:' ';display:block;width:60px;height:4px;background:", ";position:absolute;bottom:0;left:0;}}&.gradient{", "}@media ", " and ", "{font-size:40px;}"],
      textCommon,


















      HEX.blue,







      gradient,


      phone, tabletMax);




    case 'h3':
      return css(["", " font-size:36px;font-weight:300;line-height:1.25;&.uppercase{text-transform:uppercase;}&.lined{position:relative;padding-bottom:19px;&:after{content:' ';display:block;width:60px;height:4px;background:", ";position:absolute;bottom:0;left:0;}}&.centred{width:100%;text-align:center;&:after{left:50%;margin-left:-30px;}}&.gradient{", "}@media ", " and ", "{font-size:25px;}@media ", " and ", "{font-size:20px;}"],
      textCommon,


















      HEX.blue,

















      gradient,


      phone, tabletMax,



      phone, phoneMax);



    case 'h4':
      return css(["", " font-size:25px;font-weight:300;line-height:1.35;&.uppercase{text-transform:uppercase;}&.lined{position:relative;padding-bottom:19px;&:after{content:' ';display:block;width:60px;height:4px;background:", ";position:absolute;bottom:0;left:0;}}&.centred{width:100%;text-align:center;&:after{left:50%;margin-left:-30px;}}&.gradient{", "}@media ", " and ", "{font-size:20px;}"],
      textCommon,


















      HEX.darkGrey,

















      gradient,


      phone, tabletMax);



    case 'p':
      return css(["", " font-size:24px;line-height:1.45;font-weight:300;&.large{font-size:49px;line-height:1.25;@media ", " and ", "{font-size:24px;line-height:1.45;}@media ", " and ", "{font-size:16px;}}&.small{font-size:16px;@media ", " and ", "{font-size:20px;}@media ", " and ", "{font-size:16px;}}&.mini{font-size:12px;@media ", " and ", "{font-size:20px;}@media ", " and ", "{font-size:16px;}}&.gradient{", "}@media ", " and ", "{font-size:20px;}@media ", " and ", "{font-size:16px;}"],
      textCommon,









      phone, tabletMax,




      phone, phoneMax,







      phone, tabletMax,



      phone, phoneMax,







      phone, tabletMax,



      phone, phoneMax,





      gradient,


      phone, tabletMax,



      phone, phoneMax);



    default:
      return '';}

});